import React from 'react';
import styled from 'styled-components';
import JumpLink from './JumpLink';

export const DisclaimerText = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #7d7d7d;
`;

const Disclaimer: React.FunctionComponent<{ footnoteNumber?: number }> = (props) => {
  const { children, footnoteNumber } = props;

  return (
    <DisclaimerText>
      {footnoteNumber && <sup id={`disclaimer-${footnoteNumber}`}>{footnoteNumber} </sup>}
      {children}
    </DisclaimerText>
  );
};

export const DisclaimerLinkWrapper = styled.sup`
  display: inline-block;
  line-height: 0px;
  margin-left: 2px;
`;

export const DisclaimerLinkAnchor = styled(JumpLink)`
  font-size: x-small;
  text-decoration: none;
  vertical-align: top;
  color: ${({ color }: DisclaimerLinkProps) => (color ? color : '#7d7d7d;')};
`;

type DisclaimerLinkProps = {
  color?: string;
};

export const DisclaimerLink: React.FunctionComponent<DisclaimerLinkProps> = (props) => {
  const { children, color } = props;

  return (
    <>
      <DisclaimerLinkWrapper>
        <DisclaimerLinkAnchor offset={-30} href={`#disclaimer-${children}`} color={color}>
          {children}
        </DisclaimerLinkAnchor>
      </DisclaimerLinkWrapper>
    </>
  );
};

export default Disclaimer;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Disclaimer.tsx